var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "19-Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z",
    fill: "#8A1C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.71 15.29-7-7-1.42 1.42 5.3 5.29H5v2h18.59l-5.29 5.29 1.41 1.41 7-7a1 1 0 0 0 0-1.41",
    fill: "#8A1C23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowMoreArrow);
export default __webpack_public_path__ + "static/media/know-more-arrow.52a55b9a6a7de5dbcd4080edc033ca44.svg";
export { ForwardRef as ReactComponent };